import React from 'react';

export const Check = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            xmlns='http://www.w3.org/2000/svg'
            width='13'
            height='9'
            viewBox='0 0 13 9'
            fill='none'>
            <path
                d='M11.4674 0.800049L4.13411 8.13338L0.800781 4.80005'
                stroke='currentColor'
                stroke-width='1.6'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};
